import type { IntlShape } from 'react-intl';

import type { VoiceSessionState } from '../../../contracts/voice-protocol';
import type { VoiceConnectionStatus } from '../store/useVoiceAssistantStore';
import { voiceAssistantMessages as messages } from './voice-assistant.messages';

export function statusLabel(
  intl: IntlShape,
  connection: VoiceConnectionStatus,
  sessionState: VoiceSessionState,
  greetingComplete = true
): string {
  if (connection === 'connecting') return intl.formatMessage(messages.statusConnecting);
  if (connection === 'error') return intl.formatMessage(messages.statusError);
  if (connection === 'idle') return intl.formatMessage(messages.statusEnded);
  // Ahead of the greeting gate: a capture can be running before the greeting
  // settles, and "Starting…" over a live dictation is the wrong reassurance.
  if (sessionState === 'dictating') return intl.formatMessage(messages.statusDictating);
  if (!greetingComplete) {
    // Same labels as a normal turn — only suppress the false “Listening”
    // flash. Coaching copy (“your turn”, “saying hello”) got repetitive.
    return intl.formatMessage(
      sessionState === 'speaking'
        ? messages.statusSpeaking
        : messages.statusGreetingPending
    );
  }
  switch (sessionState) {
    case 'speaking':
      return intl.formatMessage(messages.statusSpeaking);
    case 'thinking':
      return intl.formatMessage(messages.statusThinking);
    case 'listening':
      return intl.formatMessage(messages.statusListening);
    default:
      return intl.formatMessage(messages.statusConnected);
  }
}

export function statusDotClass(connection: VoiceConnectionStatus): string {
  switch (connection) {
    case 'active':
      return 'bg-accent-forest';
    case 'error':
      return 'bg-validation-destructive';
    default:
      return 'bg-background-tertiary';
  }
}
